import React from "react";
import CustomGoogleMap from "./CustomGoogleMap";
import { googleApiCode } from "../../../config/constants";
import "./GoogleMapContainer.css";
import { MAPOPTIONSTYLES_INTERFACE } from "../../PlolygonServices/Utils/PlolygonServicesInterface";
import { isEmptyOrNull } from "../../../utils/DataUtils";
export interface CustomLocation {
  lat: number;
  lng: number;
}

export interface CustomMarker {
  name: string;
  location: CustomLocation;
  icon?: any;
  label?: any;
}

interface GoogleMapContainerProps {
  refMap: any;
  center: CustomLocation;
  zoom?: number;
  onIdle?: any;
  markers?: any;
  polygons?: any;
  handlePolygonClick?: any;
  posZoneMarkerInfoWindow?: any;
  openPolygonPosZoneInfoWindow?: any;
  mapOptionStyles?: MAPOPTIONSTYLES_INTERFACE[];
}

const MapContainer = (props: GoogleMapContainerProps) => {
  const { refMap, center, zoom, onIdle, markers, polygons, handlePolygonClick, posZoneMarkerInfoWindow, openPolygonPosZoneInfoWindow, mapOptionStyles } = props;


  if (isEmptyOrNull(googleApiCode)) {
    console.error("Google Maps API key is missing. Map will not be displayed.");
    return (
      <div style={{ height: `400px`, width: `100%`, display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #ccc' }}>
        <p>Map service currently unavailable.</p>
      </div>
    );
  }

  return (
    <CustomGoogleMap
      refMap={refMap}
      defaultCenter={center || { lat: 0, lng: 0 }}
      defaultZoom={zoom ?? 8}
      onIdle={onIdle}
      markers={markers}
      polygons={polygons}
      handlePolygonClick={handlePolygonClick}
      posZoneMarkerInfoWindow={posZoneMarkerInfoWindow}
      openPolygonPosZoneInfoWindow={openPolygonPosZoneInfoWindow}
      mapOptionStyles={mapOptionStyles}
    />
  );
};

export default MapContainer;
